<template>
  <section class="hero is-fullheight">
    <div class="hero-body">
      <div class="container has-text-centered">
        <router-view/>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: 'Layout-404',
  components: {
    //
  },
  props: {
    //
  },
  data: function () {
    return {
      //
    }
  },
  created: function() {
    //
  },
  computed: {
    //
  },
  beforeMount: function(){
    //
  },
  mounted: function(){
    //
  },
  methods: {
    //
  }
}
</script>

<style scoped>
</style>
<style>
</style>
